<template>
  <div class="payment">
    <vxe-grid
      border
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="columnList"
      show-footer
      max-height="300"
      :footer-method="footerMethod"
      column-min-width="120"
    >
    </vxe-grid>
  </div>
</template>
<script>
  import fullScreenDialog from '@/common/mixins/fullScreenDialog.js';
  export default {
    mixins: [fullScreenDialog],
    name: 'payment',
    computed: {
      columnList() {
        return [
          { type: 'seq', title: this.$t('table.index'), width: 60, fixed: 'left' }, // 序号
          {
            field: 'serializationJsonData.purchaseOrderNo',
            title: this.$t('batchAdd.payment.purchaseOrderNo'),
          }, // 采购管理号
          {
            field: 'serializationJsonData.externalContractNo',
            title: this.$t('batchAdd.payment.externalContractNo'),
          }, // 外部采购合同号
          {
            field: 'serializationJsonData.paymentDate',
            title: this.$t('batchAdd.payment.paymentDate'),
          }, // 付款日期
          {
            // 付款金额
            field: 'serializationJsonData.paymentAmount',
            title: this.$t('batchAdd.payment.paymentAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.serializationJsonData.paymentAmount)}
                  </span>,
                ];
              },
            },
          },
          {
            field: 'serializationJsonData.receiveCompanyName',
            title: this.$t('batchAdd.payment.receiveCompanyName'),
          }, // 收款单位
          {
            field: 'serializationJsonData.paymentType',
            title: this.$t('batchAdd.payment.paymentType'),
            formatter: this.formatterPaymentType,
          }, // 付款类别
          {
            field: 'serializationJsonData.inboundQuantity',
            title: this.$t('batchAdd.payment.inboundQuantity'),
            formatter: this.formatterInboundQuantity,
          }, // 入库吨数
          {
            field: 'serializationJsonData.unitPrice',
            title: this.$t('batchAdd.payment.unitPrice'),
            formatter: this.formatterBaseInfo,
          }, // 单价
          {
            field: 'serializationJsonData.totalAmount',
            title: this.$t('batchAdd.payment.totalAmount'),
            formatter: this.formatterBaseInfo,
          }, // 总货款
          {
            field: 'serializationJsonData.marginAmount',
            title: this.$t('batchAdd.payment.marginAmount'),
            formatter: this.formatterMarginAmount,
          }, // 保证金
          {
            field: 'serializationJsonData.marginAmountPercent',
            title: this.$t('batchAdd.payment.marginAmountPercent'),
            formatter: this.formatterMarginAmountPercent,
          }, // 保证金比例
          { field: 'serializationJsonData.mark', title: this.$t('batchAdd.payment.mark') }, // 备注
        ];
      },
    },
    data() {
      return {
        tableData: [],
      };
    },
    methods: {
      exportChildData() {
        return this.$refs.table.getTableData().fullData;
      },
      formatterPaymentType({ cellValue }) {
        let dictList = [
          ...this.$baseRequest.getDictListMapByType('payment_type'),
          ...this.$baseRequest.getDictListMapByType('receivedType'),
        ];
        let cellName = dictList.find((item) => item.value == cellValue).label;
        return cellName ? cellName : cellValue;
      },
      formatterMarginAmount({ cellValue, row }) {
        // 保证金
        let paymentType = row.serializationJsonData.paymentType;
        if (['PT01', 'PT10', 'RT15'].indexOf(paymentType) != -1) {
          // 货款、退保证金、供应商退款-退保证金
          return this.$baseRequest.formatTableColumn(cellValue);
        }
        return null;
      },
      formatterMarginAmountPercent({ cellValue, row }) {
        // 保证金比例
        let paymentType = row.serializationJsonData.paymentType;
        if (['PT01', 'PT10', 'RT15'].indexOf(paymentType) != -1) {
          // 货款、退保证金、供应商退款-退保证金
          return this.$baseRequest.formatTableColumn(cellValue, this.$globalVar.iPoint);
        }
        return null;
      },
      formatterInboundQuantity({ cellValue, row }) {
        // 入库吨数
        let paymentType = row.serializationJsonData.paymentType;
        if (paymentType == 'PT01') {
          return this.$baseRequest.formatTableColumn(cellValue, this.$globalVar.qPoint);
        }
        return null;
      },
      formatterBaseInfo({ cellValue, row, column }) {
        // 单价、总货款
        let paymentType = row.serializationJsonData.paymentType;
        if (paymentType == 'PT01') {
          let point;
          if (column.property.indexOf('Price') != -1) {
            point = this.$globalVar.pPoint;
          }
          return this.$baseRequest.formatTableColumn(cellValue, point);
        }
        return null;
      },
      footerMethod({ columns, data }) {
        let returnProps = [
          'serializationJsonData.paymentAmount',
          'serializationJsonData.inboundQuantity',
          'serializationJsonData.totalAmount',
          'serializationJsonData.marginAmount',
        ];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (returnProps.includes(column.property)) {
              let subtrahend = 0;
              data.map((item) => {
                let paymentType = item.serializationJsonData.paymentType;
                if (
                  [
                    'serializationJsonData.inboundQuantity',
                    'serializationJsonData.totalAmount',
                  ].includes(column.property)
                ) {
                  // 入库吨数和保证金
                  if (paymentType == 'PT01') {
                    // 是货款合计
                    subtrahend = this.$cal.calCommon(
                      item.serializationJsonData[
                        column.property.replace('serializationJsonData.', '')
                      ],
                      subtrahend,
                      '+'
                    );
                  }
                } else if (['serializationJsonData.marginAmount'].includes(column.property)) {
                  if (['PT01', 'PT10', 'RT15'].indexOf(paymentType) != -1) {
                    // 货款、退保证金、供应商退款-退保证金合计
                    subtrahend = this.$cal.calCommon(
                      item.serializationJsonData[
                        column.property.replace('serializationJsonData.', '')
                      ],
                      subtrahend,
                      '+'
                    );
                  }
                } else {
                  subtrahend = this.$cal.calCommon(
                    item.serializationJsonData[
                      column.property.replace('serializationJsonData.', '')
                    ],
                    subtrahend,
                    '+'
                  );
                }
              });
              let point;
              if (column.property.indexOf('Quantity') != -1) {
                point = this.$globalVar.qPoint;
              }
              return this.$baseRequest.formatTableColumn(subtrahend, point);
            }
            return null;
          }),
        ];
      },
    },
  };
</script>
